import React from "react"
import {Field} from "react-final-form";
import CheckboxWrapper from "../../Form/Checkbox";
import {FormHelperText, Link, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import {InfoSubmitEvent} from "../../../Containers/RootContainer";

interface AcceptTermsOfServiceFieldProps {
    showErrors: boolean
    values: InfoSubmitEvent
    setShowPrivacyPolicy: (value: boolean) => void
}

const AcceptTermsOfServiceField = ({ showErrors, values, setShowPrivacyPolicy }: AcceptTermsOfServiceFieldProps) => {
    const { t } = useTranslation()

    return (
        <Field
            name="acceptTermsOfUse"
            defaultValue={false}
            type="checkbox"
            error={showErrors && !values?.acceptTermsOfUse}
        >
            {(props) => (
                <>
                    <CheckboxWrapper
                        {...props}
                        checkboxProps={{size: 'large', color: 'secondary'}}
                    >
                        <Typography variant="subtitle1" className={showErrors && !values?.acceptTermsOfUse ? null : null}>
                            {t('rootContainer.iAccept')}
                            <Link onClick={() => setShowPrivacyPolicy(true)}>{t('common.termsOfUse')}</Link>
                        </Typography>
                    </CheckboxWrapper>
                    {showErrors && !values?.acceptTermsOfUse && (
                        <FormHelperText error>{t('selfService.acceptTermsOfService')}</FormHelperText>
                    )}
                </>
            )}
        </Field>
    )
}

export default AcceptTermsOfServiceField
